<template>
  <v-flex data-qa="breakdeposit-flex-p939wml">
    <Loader v-show="loaderEnabled" />
    <v-flex class="pt-6 px-4" data-qa="breakdeposit-flex-18uuqk">
      <!-- Step 1 Select Breakage Type -->
      <v-flex v-show="config.stepName === 'breakageType'" data-qa="breakdeposit-flex-5xb0v7">
        <v-card class="pl-4" elevation="0" data-qa="breakdeposit-card-qvazi6">
          <font class="title font-weight-bold"
            >{{ $t("termDepositActions.breakDeposit.whichWouldYouLike") }}
          </font>
          <v-flex data-qa="breakdeposit-flex-elgfo9">
            <v-radio-group
              v-model="formData.breakageAmountOption"
              @change="
                onBreakageAmountChange();
                isPristine();
              "
             data-qa="breakdeposit-radio-group-noungm">
              <v-radio
                :color="secondaryColor"
                class="font-weight-medium"
                :label="$t('termDepositActions.breakDeposit.fullBreakageLabel')"
                value="full"
                data-qa="full"
              ></v-radio>
              <font class="font-weight-light text--secondary pl-8 mt-n1">
                {{ $t("termDepositActions.breakDeposit.fullBreakageMsg") }}
              </font>
              <v-radio
                v-if="formData.accStatus !== 'AWAITINGFUNDS'"
                :color="secondaryColor"
                class="font-weight-regular mt-6"
                :label="$t('termDepositActions.breakDeposit.partialBreakageLabel')"
                value="partial"
                data-qa="partial"
              ></v-radio>
              <font
                class="font-weight-light subtitle-1 text--secondary pl-8 mt-n1"
              >
                {{ $t("termDepositActions.breakDeposit.partialBreakageMsg") }}
              </font>
            </v-radio-group>
            <v-flex v-if="formData.accStatus === 'AWAITINGFUNDS'" xs12 sm11 md10 lg8 xl5 class="text-left pa-4" data-qa="breakdeposit-flex-c1pzq8">
              <v-alert
                icon="mdi-information-outline"
                class="v-alert--info"
                 data-qa="breakdeposit-alert-u238st">
                <font class="body-2 font-weight-regular">{{
                  $t("termDepositActions.breakDeposit.partialBreakageTooltip")
                }}</font>
              </v-alert>
            </v-flex>
          </v-flex>
          <v-flex
            v-if="formData.breakageAmountOption === 'partial'"
            class="px-1"
           data-qa="breakdeposit-flex-ddu42r">
            <v-flex class="subtitle-1 font-weight-bold"
               data-qa="breakdeposit-flex-ke2zij">{{ $t("termDepositActions.breakDeposit.howMuchMoneyToBreak") }}
            </v-flex>
            <v-flex xs12 sm6 md5 lg4 xl4 data-qa="breakdeposit-flex-8gp99">
              <v-text-field
                v-model="formData.breakageAmount"
                class="pt-2"
                @input="validateBreakageAmount($event)"
                @change="isPristine"
                :error="error"
                :error-messages="errorMessage"
                :rules="[rules.required, rules.isAmountNumber]"
                :disabled="isFullBreakage"
                :color="primaryColor"
                :maxLength="maxAmountLength"
                filled
                dense
                data-qa="breakageAmount"
                type="number"
                @keydown="$formatter.validateAmount($event)"
              ></v-text-field>
            </v-flex>
          </v-flex>
        </v-card>
      </v-flex>
      <!-- Step 2 Select Pay Away Account -->
      <v-flex v-show="config.stepName === 'selectPayAwayAccount'" data-qa="breakdeposit-flex-1h3wd">
        <ListAccounts :currencyFormat="currencyFormat" />
      </v-flex>
      <!-- Step 3 Review Account Details -->
      <v-flex v-show="config.stepName === 'reviewAccountDetails'" data-qa="breakdeposit-flex-6hvi6l">
        <v-card class="px-4" elevation="0" data-qa="breakdeposit-card-ttgvwd">
          <font class="title font-weight-bold">
            {{ getUserName() }},
            {{ $t("termDepositActions.breakDeposit.reviewMessage1") }}
            {{ getBreakageType() }}
            {{ $t("termDepositActions.breakDeposit.reviewMessage2") }}
            {{ getRemainingDays() }}
            {{ $t("termDepositActions.breakDeposit.reviewMessage3") }}
            {{ formData.durations }}
          </font>
          <v-row class="mt-6 px-3" data-qa="breakdeposit-row-r1i0h">
            <!-- Breakage Forecast Section 1 -->
            <v-flex xs12 sm6 md6 lg6 xl6 data-qa="breakdeposit-flex-sp4t9">
              <font class="title font-weight-medium"
                >{{ $t("termDepositActions.breakDeposit.revisedROI") }}
              </font>
              <v-layout class="py-3" row wrap data-qa="breakdeposit-layout-nnboyo">
                <v-flex xs6 sm7 md6 lg5 xl5 class="body-1 font-weight-medium" data-qa="breakdeposit-flex-ubb7es">
                  {{
                    $t("termDepositActions.breakDeposit.breakageInterestRate")
                  }}
                </v-flex>
                <v-flex xs5 sm5 md5 lg6 xl6 class="body-1 font-weight-bold" data-qa="breakdeposit-flex-7q446l">
                  {{ formData.breakageInterestRate }} %
                </v-flex>
              </v-layout>
              <v-layout v-if="formData.breakagePenaltyRate > 0" class="py-3" row wrap data-qa="breakdeposit-layout-udmd9t">
                <v-flex xs6 sm7 md6 lg5 xl5 class="body-1 font-weight-medium" data-qa="breakdeposit-flex-nv0ekt">
                  {{
                    $t("termDepositActions.breakDeposit.penaltyInterestRate")
                  }}
                </v-flex>
                <v-flex
                  xs5
                  sm5
                  md5
                  lg6
                  xl6
                  class="body-1 font-weight-bold mx-n2"
                 data-qa="breakdeposit-flex-8ggdvt">
                  - {{ formData.breakagePenaltyRate }} %
                </v-flex>
              </v-layout>
              <v-flex xs12 sm9 md8 lg6 xl6 data-qa="breakdeposit-flex-ce65ga">
                <v-divider data-qa="breakdeposit-divider-lxiqvus"  />
              </v-flex>
              <v-layout class="py-3" row wrap data-qa="breakdeposit-layout-8mha8p">
                <v-flex xs6 sm7 md6 lg5 xl5 class="body-1 font-weight-medium" data-qa="breakdeposit-flex-sfp2ns">
                  {{
                    $t("termDepositActions.breakDeposit.effectiveInterestRate")
                  }}
                </v-flex>
                <v-flex xs5 sm5 md5 lg6 xl6 class="body-1 font-weight-bold" data-qa="breakdeposit-flex-dztb7o">
                  {{ formData.effectiveBreakageInterestRate }} %
                </v-flex>
              </v-layout>
            </v-flex>
            <!-- Breakage Forecast Section 2 -->
            <v-flex xs12 sm6 md6 lg6 xl6 data-qa="breakdeposit-flex-k7r8hp">
              <span class="title font-weight-medium"
                 data-qa="breakdeposit-span-lfjxte">{{ $t("termDepositActions.breakDeposit.amtCalculation") }}
              </span>
              <v-layout class="py-3" row wrap data-qa="breakdeposit-layout-4xoun">
                <v-flex xs6 sm7 md6 lg6 xl5 class="body-1 font-weight-medium" data-qa="breakdeposit-flex-fjsy2r">
                  {{ $t("termDepositActions.breakDeposit.breakageAmount") }}
                </v-flex>
                <v-flex xs5 sm5 md5 lg6 xl6 class="body-1 font-weight-bold" data-qa="breakdeposit-flex-qoxpfo">
                  <font :color="$formatter.currency.isNegativeBalance(formData.breakageAmount) ? errorColor : successColor"
                    >{{ $formatter.currency.format(formData.breakageAmount, formData.maturityDetailsCurrencyFormat) }}
                  </font>
                </v-flex>
              </v-layout>
              <v-layout class="py-3" row wrap data-qa="breakdeposit-layout-1ivyn9">
                <v-flex xs6 sm7 md6 lg6 xl5 class="body-1 font-weight-medium" data-qa="breakdeposit-flex-mmvf8u">
                  {{ $t("termDepositActions.breakDeposit.RevisedInterestAmt") }}
                </v-flex>
                <v-flex xs5 sm5 md5 lg6 xl6 class="body-1 font-weight-bold" data-qa="breakdeposit-flex-cxl0mg">
                  <font :color="$formatter.currency.isNegativeBalance(formData.breakageInterestAmount) ? errorColor : successColor">
                    {{
                      $formatter.currency.format(
                        formData.breakageInterestAmount, formData.maturityDetailsCurrencyFormat
                      )
                    }}
                  </font>
                </v-flex>
              </v-layout>
              <v-layout v-if="formData.breakageCharges > 0" class="py-3" row wrap data-qa="breakdeposit-layout-s5g7pc">
                <v-flex xs6 sm7 md6 lg6 xl5 class="body-1 font-weight-medium" data-qa="breakdeposit-flex-tq298">
                  {{ $t("termDepositActions.breakDeposit.breakageCharges") }}
                </v-flex>
                <v-flex
                  xs5
                  sm5
                  md5
                  lg6
                  xl6
                  class="body-1 font-weight-bold mx-n2"
                 data-qa="breakdeposit-flex-vbp86">
                  <font :color="$formatter.currency.isNegativeBalance(formData.breakageCharges) ? errorColor : ''">
                    - {{ $formatter.currency.format(formData.breakageCharges, formData.maturityDetailsCurrencyFormat) }}
                  </font>
                </v-flex>
              </v-layout>
              <v-layout v-if="formData.taxOnBreakageInterest > 0" class="py-3" row wrap data-qa="breakdeposit-layout-033li">
                <v-flex xs6 sm7 md6 lg6 xl5 class="body-1 font-weight-medium" data-qa="breakdeposit-flex-xcro4r">
                  {{
                    $t("termDepositActions.breakDeposit.taxOnBreakageInterest")
                  }}
                </v-flex>
                <v-flex
                  xs5
                  sm5
                  md5
                  lg6
                  xl6
                  class="body-1 font-weight-bold mx-n2"
                 data-qa="breakdeposit-flex-feb6e">
                  <font :color="$formatter.currency.isNegativeBalance(formData.taxOnBreakageInterest) ? errorColor : ''">
                    - {{
                        $formatter.currency.format(formData.taxOnBreakageInterest, formData.maturityDetailsCurrencyFormat)
                      }}
                  </font>
                </v-flex>
              </v-layout>
              <v-flex xs10 sm10 md10 lg10 xl10 data-qa="breakdeposit-flex-2fvde">
                <v-divider data-qa="breakdeposit-divider-yx0vsm"  />
              </v-flex>
              <v-layout class="py-3" row wrap data-qa="breakdeposit-layout-m4l4bm">
                <v-flex xs6 sm7 md6 lg6 xl5 class="body-1 font-weight-medium" data-qa="breakdeposit-flex-cr5ikt">
                  {{ $t("termDepositActions.breakDeposit.totalAmt") }}
                </v-flex>
                <v-flex xs5 sm5 md5 lg6 xl6 class="subtitle-1 font-weight-bold" data-qa="breakdeposit-flex-4lo2c3">
                  <font :color="$formatter.currency.isNegativeBalance(getNetAmount()) ? errorColor : successColor">
                    {{ $formatter.currency.format(getNetAmount(), formData.maturityDetailsCurrencyFormat) }}
                  </font>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-row>
        </v-card>
        <!-- OTP Component -->
        <Modal
          v-if="otpConfig.enabled"
          :config="otpConfig"
          @cancel="onOtpModalClose"
        >
          <span slot="modalContent" data-qa="breakdeposit-span-cfwkg4">
            <OtpInput :otpConfig="otpSettings" />
          </span>
        </Modal>
      </v-flex>
    </v-flex>
    <!-- Breakage Confirm Component -->
    <ConfirmDeposit
      v-if="confirmFormData.showConfimModal"
      :config="confirmFormData"
    />
  </v-flex>
</template>

<script>
import commonService from '@/service/commonService.js'
import event from '@/util/event'
import _ from 'lodash'
import store from '@/core/store'
import preload from '@/util/preload'
import Loader from '../../../components/common/Loader.vue'

export default {
  name: 'BreakDeposit',
  props: {
    config: {
      type: Object
    }
  },
  components: {
    Loader,
    Modal: () => import('@/components/common/Modal.vue'),
    OtpInput: () => import('@/components/common/OtpInput.vue'),
    ListAccounts: () =>
      import('@/views/accounts/termDepositActions/ListAccounts.vue'),
    ConfirmDeposit: () =>
      import('@/views/accounts/termDepositActions/ConfirmDeposit.vue')
  },
  data () {
    return {
      steps: [],
      loaderEnabled: false,
      formData: {
        depositAmount: '',
        interest: '',
        maturityDate: '',
        interestRate: '',
        maturityAmount: '',
        payAwayAccount: '',
        breakageAmount: '',
        breakageInterestRate: '',
        penaltyInterestRate: '',
        effectiveInterestRate: '',
        breakageInterest: '',
        breakageCharges: '',
        taxOnBreakageInterest: '',
        totalNetAmount: '',
        breakageAmountOption: '',
        breakageForecastDetailsSection1: [],
        breakageForecastDetailsSection2: [],
        partialBreakage: {},
        fullBreakage: {},
        accountNumber: '',
        accStatus: null,
        durations: '',
        maturityDetailsCurrencyFormat: '',
        payAwayAccDetails: {
          selectedAccountType: '',
          selectedInternalPayAwayAccount: '',
          selectedExternalPayAwayAccount: '',
          selectedExternalAccBeneficiaryId: '',
          enableNext: false
        }
      },
      confirmFormData: {
        showConfimModal: false
      },
      otpSettings: {
        resetPasswordTime: 10000,
        flex: 'xs12 sm12 md12 lg12 xl12'
      },
      tdDetails: null,
      beneficiaries: null,
      productDetails: null,
      isFullBreakage: true,
      errorMessage: undefined,
      error: false,
      showBreakageForecast: false,
      disableBreakageForecast: true,
      maxAmountLength: 20,
      rules: {
        required: v => !!v || this.$t('errors.common.required'),
        isAmountNumber: v =>
          new RegExp('^(\\d*\\.)?\\d+$').test(v) ||
          this.$t('errors.common.invalidInput')
      },
      toggleConfirm: false,
      otpConfig: {
        enabled: false,
        persistent: true,
        enableSave: true,
        close: true,
        saveButton: '',
        outlinedSaveBtn: false,
        title: this.$t('otp.toolBarTitle'),
        width: 400
      },
      currencyFormat: ''
    }
  },
  methods: {
    onOtpModalClose () {
      this.otpConfig.enabled = false
    },
    onFormConfirm (props) {
      switch (props.stepName) {
        case 'breakageType':
          if (this.formData.breakageAmountOption &&
          this.formData.breakageAmountOption.length) {
            event.$emit('disableNextBtn', false)
          }
          break
        case 'selectPayAwayAccount':
          if (
            (this.formData.payAwayAccDetails.selectedExternalPayAwayAccount &&
          this.formData.payAwayAccDetails.selectedExternalPayAwayAccount.length) ||
        (this.formData.payAwayAccDetails.selectedInternalPayAwayAccount &&
          this.formData.payAwayAccDetails.selectedInternalPayAwayAccount.length)) {
            event.$emit('disableNextBtn', false)
          } else {
            event.$emit('disableNextBtn', true)
          }
          if (this.tdDetails && this.tdDetails.allowPayAwaytoOtherBank) {
            event.$emit('payAwayAccType', {
              accType: 'External',
              action: 'Break'
            })
          } else {
            event.$emit('payAwayAccType', {
              accType: 'Internal',
              action: 'Break'
            })
          }
          break
        case 'reviewAccountDetails':
          this.getBreakageForecast()
          break
        default:
      }
    },
    getBreakageType () {
      return this.formData.breakageAmountOption === 'full' ? 'Terminating' : 'Partially Breaking'
    },
    getRemainingDays () {
      if (this.config.step === 3) {
        const todaysDate = new Date()
        const formattedStartDate = this.$formatter.formatDate(this.formData.startDate).split('-').join('/')
        const formattedMaturityDate = this.$formatter.formatDate(this.formData.maturityDate).split('-').join('/')
        const startDate = new Date(`${formattedStartDate.split('/')[1]} / ${formattedStartDate.split('/')[0]} / ${formattedStartDate.split('/')[2]}`)
        const currentDate = new Date(todaysDate.toLocaleDateString())
        const endDate = new Date(`${formattedMaturityDate.split('/')[1]} / ${formattedMaturityDate.split('/')[0]} / ${formattedMaturityDate.split('/')[2]}`)
        const diffTime = Math.abs(endDate - startDate)
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24))
        const diffInCurrentTime = Math.abs(endDate - currentDate)
        const diffInCurrentDays = Math.ceil(diffInCurrentTime / (1000 * 60 * 60 * 24))
        let coveredDays = diffDays - diffInCurrentDays
        coveredDays = coveredDays === 1 ? `${coveredDays} day` : `${coveredDays} days`
        return coveredDays
      }
    },
    getPayAwayAcc () {
      return this.formData.payAwayAccDetails.selectedAccountType === 'Internal' ? this.formData.payAwayAccDetails.selectedInternalPayAwayAccount : this.formData.payAwayAccDetails.selectedExternalPayAwayAccount
    },
    getUserName () {
      const data = store.getters['profileStore/profileData'].customerDetails
      if (data) {
        return data.fullName || 'Roger Moore'
      }
    },
    getNavigationIcon () {
      return this.getSvgIconSrc('Deposit2')
    },
    isPristine () {
      this.toggleConfirm = true
      event.$emit('closeDepositDataSanity', this.toggleConfirm)
    },
    async getFixedDepositDetails (accountNumber) {
      const response = await commonService.getFixedDepositDetails(
        accountNumber
      )
      this.tdDetails = response
      this.currencyFormat = response.maturityAmount.currency
      this.formData.depositAmount = response.currentBalance.value
      this.formData.currentBalance = response.currentBalance.value
      this.formData.interest = response.interestAmount.value
      this.formData.maturityDate = response.maturityDate
      this.formData.startDate = response.startDate
      this.formData.interestRate = response.interestRate
      this.formData.maturityAmount = response.maturityAmount.value
      this.formData.payAwayAccount = response.payCapitalToAccount
      this.formData.accStatus = response.status
      this.formData.durations = `${response.duration}  ${
        response.duration > 1
          ? _.capitalize(response.durationType)
          : _.capitalize(response.durationType).slice(0, -1)
      }`
      if (response && response.allowPayAwaytoOtherBank) {
        this.getBeneficiaries()
      }
    },
    async getTermDepositBreakageForecastDetails (accountNumber) {
      const self = this
      const data = {
        breakageAmount: {
          value: self.formData.breakageAmountOption === 'full' ? self.formData.breakageAmount : self.formData.breakageAmount[0],
          currency: self.productDetails.currency
        },
        breakageDate: new Date().toISOString().slice(0, 10)
        // TODO penaltyInterestRate: '0.00'
      }
      const response = await commonService.getTermDepositBreakageForecastDetails(
        accountNumber,
        data
      )
      if (response && !response.causes) {
        const self = this
        self.formData.maturityDetailsCurrencyFormat = response.currentBalance.currency
        self.formData.currentBalance = response.currentBalance.value
        self.formData.breakageInterestRate =
          response.breakageInterestRate || '0'
        self.formData.breakagePenaltyRate = response.breakagePenaltyRate || '0'
        self.formData.effectiveBreakageInterestRate =
          response.effectiveBreakageInterestRate || '0'
        self.formData.breakageInterestAmount =
          response.breakageInterestAmt.value
        self.formData.remainingAmount = response.remainingAmt.value
        self.formData.maturityInterestAmount =
          response.maturityInterestAmount.value
        self.formData.remainingAmountInterestRate =
          response.remainingAmtInterestRate
        self.formData.breakageCharges = response.breakageCharges.value
        self.formData.taxOnBreakageInterest = response.taxOnInterest.value
        self.showBreakageForecast = true
        this.errorMessage = undefined
        this.error = false
      } else {
        this.config.step--
        this.config.stepName = 'selectPayAwayAccount'
      }
    },
    onBreakageAmountChange () {
      this.showBreakageForecast = false
      if (this.formData.breakageAmountOption === 'full') {
        this.disableBreakageForecast = false
        this.formData.breakageAmount = this.formData.currentBalance
        this.isFullBreakage = true
      } else {
        this.disableBreakageForecast = true
        this.formData.breakageAmount = ''
        this.isFullBreakage = false
      }
      event.$emit('disableNextBtn', this.disableBreakageForecast)
    },
    getNetAmount () {
      return (
        parseFloat(this.formData.breakageAmountOption === 'full' ? this.formData.breakageAmount : this.formData.breakageAmount ? this.formData.breakageAmount[0] : 0) +
        parseFloat(this.formData.breakageInterestAmount) -
        parseFloat(this.formData.breakageCharges) -
        parseFloat(this.formData.taxOnBreakageInterest)
      )
    },
    restrictDecimal (val) {
      if (val && val.length) {
        // Restrict the input to 2 decimal places
        this.formData.breakageAmount = val.match(/^\d+\.?\d{0,2}/)
      }
    },
    validateBreakageAmount (e) {
      this.isBreakageForecastDisable()
      this.restrictDecimal(e)
      if (
        parseFloat(this.formData.breakageAmount) >
        parseFloat(this.formData.currentBalance)
      ) {
        this.errorMessage = this.$t('termDepositActions.breakDeposit.greaterThanMaturityAmtError')
        this.error = true
      } else if (parseFloat(this.formData.breakageAmount) === 0) {
        this.errorMessage = this.$t('termDepositActions.breakDeposit.zeroAmtError')
        this.error = true
      } else {
        this.errorMessage = undefined
        this.error = false
      }
    },
    isBreakageForecastDisable () {
      if (
        this.formData.breakageAmount.length === 0 ||
        parseFloat(this.formData.breakageAmount) <= 0 ||
        parseFloat(this.formData.breakageAmount) >
          parseFloat(this.formData.currentBalance)
      ) {
        this.disableBreakageForecast = true
      } else {
        this.disableBreakageForecast = false
      }
      event.$emit('disableNextBtn', this.disableBreakageForecast)
    },
    getBreakageForecast () {
      if (
        parseFloat(this.formData.breakageAmount) >
        parseFloat(this.formData.currentBalance)
      ) {
        this.errorMessage =
          'Entered amount should not be greater than Maturity amount'
        this.error = true
      } else {
        this.getTermDepositBreakageForecastDetails(this.formData.accountNumber)
      }
    },
    async breakTermDeposit () {
      const self = this
      const data = {
        breakageAmount: {
          value: self.formData.breakageAmountOption === 'full' ? self.formData.breakageAmount : self.formData.breakageAmount[0],
          currency: self.productDetails.currency
        }
      }
      let response
      if (this.formData.payAwayAccDetails.selectedAccountType === 'External') {
        data.payawayBeneficiaryId = this.formData.payAwayAccDetails.selectedExternalAccBeneficiaryId
        response = await commonService.terminateTermDeposit(
          self.productDetails.accountId,
          data
        )
      } else {
        data.payawayAccountId = this.formData.payAwayAccDetails.selectedInternalPayAwayAccount
        response = await commonService.terminateTermDeposit(
          self.productDetails.accountId,
          data
        )
      }
      if (response && !response.data) {
        await preload.getListOfAccounts(JSON.parse(sessionStorage.getItem('username')))
        this.getFormData(response)
      }
    },
    async getBeneficiaries () {
      const resp = await commonService.getBeneficiaries(
        JSON.parse(sessionStorage.getItem('username'))
      )
      if (resp) {
        this.beneficiaries = resp.items
      }
    },
    getFormData (respData) {
      this.confirmFormData = { showConfimModal: false }
      if (respData) {
        this.confirmFormData.remainingAmount = this.$formatter.currency.format(respData.currentBalance.value, this.formData.maturityDetailsCurrencyFormat)
        this.confirmFormData.interestRate = respData.interestRate
        this.confirmFormData.interestAtMaturity = this.$formatter.currency.format(respData.interestAmount.value, this.formData.maturityDetailsCurrencyFormat)
        this.confirmFormData.maturityAmount = this.$formatter.currency.format(respData.maturityAmount.value, this.formData.maturityDetailsCurrencyFormat)
        this.confirmFormData.breakageAmount = this.$formatter.currency.format(this.getNetAmount(), this.formData.maturityDetailsCurrencyFormat)
        this.confirmFormData.breakageType = this.formData.breakageAmountOption
        this.confirmFormData.payAwayAccount = this.getPayAwayAcc()
        this.confirmFormData.username = this.getUserName()
        this.confirmFormData.showConfimModal = true
        this.confirmFormData.action = 'break'
        this.confirmFormData.tdDetails = this.tdDetails
      }
    }
  },
  created () {
    const self = this
    if (this.$route.params.product !== undefined) {
      this.productDetails = this.$route.params.product
      this.formData.accountNumber = this.productDetails.accountId
    } else {
      if (this.$route.params.routeFrom) {
        this.$router.push({ path: this.$route.params.routeFrom })
      }
    }
    this.getFixedDepositDetails(this.formData.accountNumber)
    event.$on('listAccounts', args => {
      self.formData.payAwayAccDetails.selectedAccountType =
        args.selectedAccountType
      if (args.selectedAccountType === 'Internal') {
        self.formData.payAwayAccDetails.selectedExternalPayAwayAccount = ''
        self.formData.payAwayAccDetails.selectedExternalAccBeneficiaryId = ''
        self.formData.payAwayAccDetails.selectedInternalPayAwayAccount =
            args.selectedInternalPayAwayAccount
      }
      if (args.selectedAccountType === 'External') {
        self.formData.payAwayAccDetails.selectedInternalPayAwayAccount = ''
        self.formData.payAwayAccDetails.selectedExternalPayAwayAccount =
        args.selectedExternalPayAwayAccount.accountIdentification
        self.formData.payAwayAccDetails.selectedExternalAccBeneficiaryId =
        args.selectedExternalPayAwayAccount.beneficiaryId
      }
      if (
        (self.formData.payAwayAccDetails.selectedExternalPayAwayAccount &&
          self.formData.payAwayAccDetails.selectedExternalPayAwayAccount.length) ||
        (self.formData.payAwayAccDetails.selectedInternalPayAwayAccount &&
          self.formData.payAwayAccDetails.selectedInternalPayAwayAccount.length)) {
        event.$emit('disableNextBtn', false)
      } else {
        event.$emit('disableNextBtn', true)
      }
    })
    event.$on('onFormConfirm', args => {
      this.onFormConfirm(args)
    })
    event.$on('finalStep', async args => {
      await this.breakTermDeposit()
    })
    event.$on('verifyOTP', args => {
      this.otpConfig.enabled = true
    })
    event.$on('IS_OTP_VALID', (val) => {
      if (val && this.otpConfig.enabled) {
        this.otpConfig.enabled = false
        this.breakTermDeposit()
      }
    })
  },
  beforeDestroy () {
    event.$off('listAccounts')
    event.$off('onFormConfirm')
    event.$off('verifyOTP')
    event.$off('IS_OTP_VALID')
    event.$off('finalStep')
  }
}
</script>
<style >
.v-input--selection-controls .v-input__slot > .v-label, .v-input--selection-controls .v-radio > .v-label {
    font-size: large;
}
</style>
